export default __webpack_public_path__ + "static/media/all-offers-sec2.c729bccf.jpg";